import React, { useContext, useEffect, useState } from "react";
import { EditOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Modal, Radio, Row, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { setAgeId, setProfID, updateAge, updateAgeName } from "../../Reducer/localStorageSlice";
import { getRequest, putRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import phoneProfile from "../../assets/images/Phone-Icon.svg";
import proftag from "../../assets/images/Tag.svg";
import username from "../../assets/images/User.svg";
import ageIcon from "../../assets/images/age.svg";
import mail from "../../assets/images/email.svg";
import ethnicityIcon from "../../assets/images/ethnicity.svg";
import gender from "../../assets/images/gender.svg";
import profilepic from "../../assets/images/profile-pic.svg";
import userImg from '../../assets/newImages/User.svg';
import { Back } from "../../components/Icons/Icons";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import { GlobalContext } from "../../components/globalContext/GlobalContext";
import "../editProfile/EditProfile.scss";
import { inputFieldCharLimit } from "../../config";
import { navBarRouterPathURl } from "../../utils/constants";
import { setUserProfile } from "../../Reducer/globalSlice";

export default function EditProfilePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const localData = useSelector((state) => state?.localStorage)
  const { accessToken } = localData
  const [form] = Form.useForm();
  const { setEndUserDetails, setProfileUpdated } = useContext(GlobalContext);
  const [profileData, setProfileData] = useState();
  const [profilePicData, setProfilePicData] = useState(null);
  const [ageGroups, setAgeGroups] = useState([]);
  const [ageGroupData, setAgeGroupsData] = useState([]);
  const [selectedAgeGroupsData, setSelectedAgeGroupsData] = useState();
  const [ethnicity, setEthnicity] = useState();
  const [viewProfile, setViewProfile] = useState(true);

  const [showAlert, setShowAlert] = useState(false);
  const [isActive, setActive] = useState("false");
  const [, setProfilePic] = useState(null);
  const [existingProfilePic, setExistingProfilePic] = useState(null)

  const is1920 = useMediaQuery({ width: 1920 });
  const is1366 = useMediaQuery({ width: 1366 });
  const is1240 = useMediaQuery({ width: 1024 });
  const is820 = useMediaQuery({ width: 820 });
  const is768 = useMediaQuery({ width: 768 });
  const is320 = useMediaQuery({ width: 320 });
  const isSmallScreen = useMediaQuery({ minWidth: 320, maxWidth: 767 });
  const isMobileScreenExcept320 = useMediaQuery({
    minWidth: 375,
    maxWidth: 767,
  });

  const columnGap = is1920 ? 4 : is768 || is820 ? 8 : 6;
  const EditSectionColumnGap =
    is1920 ? 5 : is820 || is768 ? 14 : is1366 ? 8 : 10;

  const handleProfilePicUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfilePic(URL.createObjectURL(file));
      setExistingProfilePic(URL.createObjectURL(file));

      setProfilePicData({
        file: file,
        mediaProperty: {
          id: generateRandomId(),
          name: file.name,
          extension: file.name.split(".").pop(),
        },
        mediaType: "IMAGE",
      });
    }
  };




  const generateRandomId = () => {
    return `${Math.random().toString(36).substring(2, 15)}-${Math.random()
      .toString(36)
      .substring(2, 15)}`; // Generate a random ID
  };

  const getProfileData = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,

      };
      const response = await getRequest(
        userapiservice.getEndUserDetails(),
        headers,
        false
      );
      if (response) {
        setProfileData(response);
        if (response?.ageGroup) {
          getAgeData(response?.ageGroup?.id);
          setSelectedAgeGroupsData(response?.tag?.id);
        }
      }
    } catch (e) {
      Modal.error({
        title: "profile Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };

  const getAgeGroups = async () => {
    try {
      const response = await getRequest(userapiservice.getEndUserAgeGroups());
      setAgeGroups(response);

    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };

  const getAgeData = async (value) => {
    try {
      const response = await getRequest(userapiservice.getWhatDoYouDo(value));
      setAgeGroupsData(response);
    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };
  useEffect(() => {
    form.resetFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileData]);



  const submitHandler = async (data) => {
    const headers = {
      Authorization: `Bearer ${accessToken}`,

    };

    const formData = new FormData();

    let endUserDetailsInput = {
      ...data,
    };

    if (profilePicData?.file) {
      formData.append("media", profilePicData.file, profilePicData.file.name);

      endUserDetailsInput = {
        ...endUserDetailsInput,
        media: {
          mediaProperty: {
            id: profilePicData.mediaProperty.id,
            name: profilePicData.mediaProperty.name,
            extension: profilePicData.mediaProperty.extension,
          },
          mediaType: profilePicData.mediaType,
        },
      };
    }

    const endUserDetailsInputBlob = new Blob(
      [JSON.stringify(endUserDetailsInput)],
      { type: "application/json" }
    );
    formData.append("endUserDetailsInput", endUserDetailsInputBlob);

    const parsedBlobContent = JSON.parse(await endUserDetailsInputBlob.text());

    const formDataObject = {};
    formData.forEach((value, key) => {
      formDataObject[key] =
        value instanceof Blob ? parsedBlobContent : value instanceof File ? value.name : value;
    });

    setEndUserDetails(formDataObject);

    try {
      const response = await putRequest(
        userapiservice.getEndUserDetails(),
        formData,
        headers
      );

      if (response) {
        setProfileUpdated(true);
        const AGEname =
          ageGroups?.find((ageGroup) => ageGroup.id === data.ageId)?.ageGroup ||
          "";
        setLocalAge(AGEname, data.ageId);
        dispatch(setProfID(response?.tag?.id))
        getAgeGroups();
        getProfileData();
        setViewProfile(true);
        toast.success(<ToastComponent type={'Success'} message={'Profile Updated Successfully'} />)
        // window.location.reload();
        dispatch(setUserProfile(response))
      }
    } catch (error) {
      console.error(error);
      toast.error(<ToastComponent type={'Error'} message={error?.message || 'Failed to update profile'} />)
    }
  };


  const ageGroupDataChange = async (groupData) => {
    setSelectedAgeGroupsData(groupData);
  };

  const toggleClass = () => {
    setActive(!isActive);
  };

  const setLocalAge = (value, id) => {
    if (value === "< 18") {
      dispatch(updateAge("18"))
      dispatch(setAgeId(id))
      dispatch(updateAgeName(value))
    } else if (value === "19 - 23") {
      dispatch(updateAge("23"))
      dispatch(setAgeId(id))
      dispatch(updateAgeName(value))
    } else if (value === "24 - 37") {
      dispatch(updateAge("37"))
      dispatch(setAgeId(id))
      dispatch(updateAgeName(value))
    } else if (value === "38 - 53") {
      dispatch(updateAge("53"))
      dispatch(setAgeId(id))
      dispatch(updateAgeName(value))
    } else if (value === "54+") {
      dispatch(updateAge("53"))
      dispatch(setAgeId(id))
      dispatch(updateAgeName(value))
    }
  };

  const setEthnicityHandler = (e) => {
    setEthnicity(e);
  };

  const handleEditDetailsClick = async () => {
    getAgeGroups();
    await getProfileData();
    setViewProfile(false);
  };

  useEffect(() => {
    getAgeGroups();
    getProfileData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    const getProfilePic = async () => {
      try {
        const headers = {
          Authorization: `Bearer ${accessToken}`,

        };
        const response = await getRequest(
          userapiservice.getEndUserDetails(),
          headers
        );

        if (response) {
          setExistingProfilePic(response?.mediaLink)
        }
      } catch (error) {

      }
    }

    getProfilePic()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="wrapper-edit-profile">
      {viewProfile ? (
        <div className="edit-profile-header">
          <div
            className="edit-profile-backarrow"
            onClick={() => navigate(`${navBarRouterPathURl}`)}
          >
            {!isSmallScreen && <Back />}
            Profile
          </div>
          <div
            className="edit-detail-button-container"
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <button
              className="edit-details-button"
              onClick={handleEditDetailsClick}
            >
              Edit Details
            </button>
          </div>
        </div>
      ) : (
        <div className="edit-profile-backarrow" onClick={() => navigate(-1)}>
          {!isSmallScreen && <Back />}
          Edit Profile
        </div>
      )}

      <div className="profile-card-container">
        {viewProfile ? (
          <div className="partner-details userProfileInfoStyle">



            <div>
              {profileData?.mediaLink && (
                <div className="profileInfoStyleRow">
                  <div className="profileInfoStyleCol">
                    <div className="titleWithIcon">
                      <div className="withIcon align_right"><img src={profilepic} alt="profile-pic"></img></div>
                      <div className="withTitle" >Profile Picture:</div>
                    </div>
                  </div>
                  <div className="profileInfoStyleCol">
                    {profileData?.mediaLink ? (
                      <img
                        src={profileData?.mediaLink}
                        alt="User Profile"
                        className="user-profile-pic"
                      />
                    ) : (
                      <p>No profile picture uploaded</p>
                    )}
                  </div>
                </div>
              )}
              <div className="profileInfoStyleRow">
                <div className="profileInfoStyleCol padding_bottom">
                  <div className="titleWithIcon">
                    <div className="withIcon"> <img src={username} alt="username"></img></div>
                    <div className="withTitle"> <label>Username:</label></div>
                  </div>
                </div>
                <div className="profileInfoStyleCol"> <p>{profileData?.userName ? profileData?.userName : ""}</p></div>
              </div>
              <div className="profileInfoStyleRow padding_bottom">
                <div className="profileInfoStyleCol">
                  <div className="titleWithIcon">
                    <div className="withIcon"> <img src={mail} alt="mail"></img></div>
                    <div className="withTitle"><label>Email:</label></div>
                  </div>
                </div>
                <div className="profileInfoStyleCol"> <p>{profileData?.email ? profileData?.email : ""}</p></div>
              </div>
              <div className="profileInfoStyleRow">
                <div className="profileInfoStyleCol">
                  <div className="titleWithIcon">
                    <div className="withIcon"><img src={phoneProfile} alt="phone"></img></div>
                    <div className="withTitle"> <label>Phone:</label></div>
                  </div>
                </div>
                <div className="profileInfoStyleCol">
                  <p>
                    {profileData?.phoneNumber ? profileData?.phoneNumber : ""}
                  </p>
                </div>
              </div>
              <div className="profileInfoStyleRow">
                <div className="profileInfoStyleCol">
                  <div className="titleWithIcon">
                    <div className="withIcon"><img src={ageIcon} alt="age"></img></div>
                    <div className="withTitle"> <label>Age:</label></div>
                  </div>
                </div>
                <div className="profileInfoStyleCol">
                  <p>
                    {profileData?.ageGroup?.ageGroup
                      ? profileData?.ageGroup?.ageGroup
                      : ""}
                  </p>
                </div>
              </div>

              {profileData?.gender && (
                <div className="profileInfoStyleRow">
                  <div className="profileInfoStyleCol">
                    <div className="titleWithIcon">
                      <div className="withIcon"><img src={gender} alt="gender"></img></div>
                      <div className="withTitle"><label>Gender:</label></div>
                    </div>
                  </div>
                  <div className="profileInfoStyleCol">
                    <p>{profileData?.gender ? profileData?.gender : ""}</p>
                  </div>
                </div>
              )}

              {profileData?.ethnicity && (
                <div className="profileInfoStyleRow">
                  <div className="profileInfoStyleCol">
                    <div className="titleWithIcon">
                      <div className="withIcon"> <img src={ethnicityIcon} alt="ethnicity"></img></div>
                      <div className="withTitle"><label>Ethnicity:</label></div>
                    </div>
                  </div>
                  <div className="profileInfoStyleCol">
                    <p>
                      {profileData?.ethnicity ? profileData?.ethnicity : ""}
                    </p>
                  </div>
                </div>
              )}

              {profileData?.tag?.id && (
                <div className="profileInfoStyleRow">
                  <div className="profileInfoStyleCol">
                    <div className="titleWithIcon">
                      <div className="withIcon"> <img src={proftag} alt="proftag"></img></div>
                      <div className="withTitle"> <label>What do you do?:</label></div>
                    </div>
                  </div>
                  <div className="profileInfoStyleCol">
                    <p>
                      {profileData?.tag?.userTag
                        ? profileData?.tag?.userTag
                        : ""}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="partner-details userProfileInfoStyle">

            {Object.keys(profileData).length > 0 ? (
              <Form
                name="editForm"
                form={form}
                onFinish={submitHandler}
                className="ProfileForm"
                initialValues={{
                  email: profileData && profileData?.email,
                  userName: profileData && profileData?.userName,
                  ageId: profileData && profileData?.ageGroup?.id,
                  gender: profileData && profileData?.gender,
                  ethnicity: profileData && profileData?.ethnicity,
                  // tagId: profileData && profileData?.tagId
                  tagId: selectedAgeGroupsData,
                }}
              >

                {/* Profile Pic Upload */}
                <div className="profileInfoStyleRow">
                  <div className="profileInfoStyleCol">
                    <div className="titleWithIcon">
                      <div className="withIcon">
                        <img src={profilepic} alt="profile-pic" />
                      </div>
                      <div className="withTitle">
                        <label>Profile Picture</label>
                      </div>
                    </div>
                  </div>

                  <div className="profileInfoStyleCol">
                    {/* ✅ Form.Item should wrap the actual input field */}
                    <Form.Item
                      name="media"
                      valuePropName="fileList"
                      getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.target?.files)}
                      style={{ marginBottom: 0 }}
                      rules={[{ required: false }]} // make true if upload required
                    >
                      <div
                        className="profile-pic-container"
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <div style={{ position: "relative" }}>
                          <img
                            src={existingProfilePic || userImg}
                            alt="Profile"
                            style={{
                              width: is1920 ? "80px" : "60px",
                              height: is1920 ? "80px" : "60px",
                              borderRadius: "50%",
                              border: "1px solid #3067AE",
                              objectFit: "cover",
                            }}
                          />

                          <div
                            className="profile-pic-edit-icon"
                            onClick={() => document.getElementById("file-upload").click()}
                            
                          >
                            <EditOutlined
                              style={{
                                fontSize: is1920 ? "18px" : "15px",
                                color: "#3067AE",
                              }}
                            />
                          </div>
                        </div>

                        <input
                          id="file-upload"
                          type="file"
                          accept="image/*"
                          onChange={handleProfilePicUpload}
                          className="file-input"
                          style={{ display: "none" }}
                        />
                      </div>
                    </Form.Item>
                  </div>
                </div>


                {/* ========================== */}

                <div className="profileInfoStyleRow height_inc">
                  <div className="profileInfoStyleCol">
                    <div className="titleWithIcon move_up">
                      <div className="withIcon"><img src={username} alt="username" /></div>
                      <div className="withTitle"><label>Username</label></div>
                    </div>
                  </div>

                  <div className="profileInfoStyleCol">
                    <Form.Item
                      name="userName"
                      rules={[{ required: true, message: "Username is required" }]}
                    >
                      <Input placeholder="UserName" maxLength={inputFieldCharLimit} className="label-values"/>
                    </Form.Item>
                  </div>
                </div>

                <div className="profileInfoStyleRow height_inc">
                  <div className="profileInfoStyleCol">
                    <div className="titleWithIcon move_up">
                      <div className="withIcon"><img src={mail} alt="mail" /></div>
                      <div className="withTitle"><label>Email</label></div>
                    </div>
                  </div>
                  <div className="profileInfoStyleCol">
                    <Form.Item
                      name="email"
                      validateFirst={true}
                      rules={[
                        { required: true, message: "Email is required" },
                        { type: "email", message: "Enter valid email" },
                      ]}
                    >
                      <Input
                        className="label-values"
                        placeholder="Email"
                        maxLength={inputFieldCharLimit}
                      />
                    </Form.Item>
                  </div>
                </div>

                <div className="profileInfoStyleRow">
                  <div className="profileInfoStyleCol">
                    <div className="titleWithIcon">
                      <div className="withIcon">
                        <img src={phoneProfile} alt="phone" />
                      </div>
                      <div className="withTitle">
                        <label>Phone</label>
                      </div>
                    </div>
                  </div>

                  <div className="profileInfoStyleCol">
                    {profileData?.phoneNumber ? profileData?.phoneNumber : ""}
                  </div>
                </div>


                <div className="profileInfoStyleRow">
                  <div className="profileInfoStyleCol">
                    <div className="titleWithIcon">
                      <div className="withIcon">
                        <img src={ageIcon} alt="age" />
                      </div>
                      <div className="withTitle">
                        <label>Age</label>
                      </div>
                    </div>
                  </div>

                  <div className="profileInfoStyleCol">
                    {/* ✅ Move Form.Item directly around Radio.Group */}
                    <Form.Item
                      name="ageId"
                      rules={[{ required: true, message: "Age is required" }]}
                    >
                      <Radio.Group
                        className="label-values"
                        size={is320 ? "medium" : "large"}
                        buttonStyle="solid"
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          getAgeData(selectedId);
                          toggleClass();
                          setLocalAge(
                            ageGroups.find((a) => a.id === selectedId)?.ageGroup,
                            selectedId
                          );
                          form.setFieldValue("tagId", null);
                        }}
                      >
                        {ageGroups && ageGroups.length > 0
                          ? ageGroups.slice(1).map((ageGroup) => (
                            <Radio.Button
                              key={ageGroup?.id}
                              className="ageGroup-buttons"
                              value={ageGroup?.id}
                            >
                              {ageGroup?.value}
                            </Radio.Button>
                          ))
                          : ""}
                      </Radio.Group>
                    </Form.Item>
                  </div>
                </div>


                <div className="profileInfoStyleRow">
                  <div className="profileInfoStyleCol">
                    <div className="titleWithIcon">
                      <div className="withIcon">
                        <img src={gender} alt="gender" />
                      </div>
                      <div className="withTitle">
                        <label>Gender</label>
                      </div>
                    </div>
                  </div>

                  <div className="profileInfoStyleCol">
                    <Form.Item name="gender">
                      <Select
                        className="label-values"
                        popupClassName="gender-menu"
                        placeholder="Select Gender (optional)"
                        allowClear
                      >
                        <Select.Option value="Male">Male</Select.Option>
                        <Select.Option value="Female">Female</Select.Option>
                        <Select.Option value="Others">Others</Select.Option>
                      </Select>
                    </Form.Item>
                  </div>
                </div>


                <div className="profileInfoStyleRow">
                  <div className="profileInfoStyleCol">
                    <div className="titleWithIcon">
                      <div className="withIcon">
                        <img src={ethnicityIcon} alt="ethnicity" />
                      </div>
                      <div className="withTitle">
                        <label>Ethnicity</label>
                      </div>
                    </div>
                  </div>

                  <div className="profileInfoStyleCol">
                    <Form.Item name="ethnicity">
                      <Select
                        className="label-values"
                        placeholder="Select Ethnicity (optional)"
                        onChange={(value) => setEthnicityHandler(value)}
                        allowClear
                      >
                        <Select.Option value="Indian">Indian</Select.Option>
                        <Select.Option value="American">American</Select.Option>
                        <Select.Option value="British">British</Select.Option>
                        <Select.Option value="African">African</Select.Option>
                      </Select>
                    </Form.Item>
                  </div>
                </div>


                <div className="profileInfoStyleRow">
                  <div className="profileInfoStyleCol">
                    <div className="titleWithIcon">
                      <div className="withIcon">
                        <img src={proftag} alt="prof" />
                      </div>
                      <div className="withTitle">
                        <label>What do you do?</label>
                      </div>
                    </div>
                  </div>

                  <div className="profileInfoStyleCol">
                    {/* ✅ Move Form.Item directly around the Select */}
                    <Form.Item
                      name="tagId"
                      rules={[{ required: true, message: "What do you do? is required" }]}
                    >
                      <Select
                        className="customSelect label-values"
                        placeholder="Select your role"
                        onChange={(value) => ageGroupDataChange(value)}
                      >
                        {ageGroupData?.map((item) => (
                          <Select.Option key={item?.id} value={item?.id}>
                            {item?.value || "N/A"}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>


                <div className="profileInfoStyleRow">
                  <div className="profileInfoStyleCol">
                    {/* optional — if you want to keep the same structure */}
                    <div className="titleWithIcon">
                      <div className="withIcon"></div>
                      <div className="withTitle"></div>
                    </div>
                  </div>

                  <div className="profileInfoStyleCol">
                    {/* ✅ Combine buttons inside one Form.Item */}
                    <Form.Item style={{ marginBottom: 0 }}>
                      <div className="profile-buttons" style={{ textAlign: 'right' }}>
                        <Button
                          className="profile-cancel-btn"
                          onClick={() => {
                            setProfilePic(null);
                            setViewProfile(true);
                          }}
                        >
                          Cancel
                        </Button>

                        <Button
                          className="profile-submit-btn"
                          htmlType="submit"
                          type="primary"
                          style={{ marginLeft: 10 }}
                        >
                          Save
                        </Button>
                      </div>
                    </Form.Item>
                  </div>
                </div>

               
              </Form>
            ) : (
              ""
            )}
          </div>
        )}
        {showAlert && (
          <div className="alert-container">
            <label
              className="age-alert"
              style={{ color: "red", width: "100%" }}
            >
              Please set age!
            </label>
          </div>
        )}
      </div>
    </div>
  );
}
